import React, { useEffect, useState } from 'react';
import CustomQuestBox from '../components/globals/CustomQuestBox';
import CustomBusinessMoneyButton from '../components/globals/CustomBusinessMoneyButton';
import BuyCoinComponent from '../components/globals/BuyCoinComponent';
import QuestionItem from '../components/globals/QuestionItem';
import CustomModal from '../components/globals/CustomModal';
import { useLocation, useNavigate } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { isLoaderState } from '../store/RecoilStore';
import { ENDPOINTS } from '../utils/EndPoint';
import { oceanAtom } from '../store/oceanAtom';
import { userAtom } from '../store/authAtom';
import { apiGetAuth, apiPost } from '../utils/Api';
import CustomPrimaryButton from '../components/globals/CustomPrimaryButton'
import CustomSecondaryButton from '../components/globals/CustomSecondaryButton';

function Quest() {
  const [lastCompleteIndex, setLastCompleteIndex] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [showGuestModal, setGuestModal] = useState(false);
  const [oceans, setOceans] = useState([]);
  const [stages, setStages] = useState([]);
  const [selectedQuest, setSelectedQuest] = useState(null);
  const [selectedQuestId, setSelectedQuestId] = useState(null);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [isLoaderInfo, setIsLoaderInfo] = useRecoilState(isLoaderState);
  const [ocean, setOcean] = useRecoilState(oceanAtom);
  const [user, setUser] = useRecoilState(userAtom);
  const location = useLocation();

  const navigate = useNavigate();

  // Handles quest click and opens confirmation modal if allowed
  const handleQuestClick = (quest, index) => {
    if (index <= lastCompleteIndex) {
      setSelectedQuest(quest);
      setSelectedQuestId(quest?.id);
      setShowConfirmationModal(true);
    }
  };

  useEffect(() => {
    if (stages) {
      setGuestModal(true);
    }
  }, [stages]);

  // Selects an ocean and fetches quests
  const handleSelectOcean = (item) => {
    setOcean(item);
    apiPost(
      ENDPOINTS.UserSelectedOption,
      { ocean_id: item?.id },
      () => {
        getQuests(item?.id);
        setShowModal(false);
      },
      (err) => console.error('Error updating user selected option', err)
    );
  };

  // Deducts coins for quest entry
  const startDeductCoins = (questId) => {
    const payload = { stage_id: questId, ocean_id: ocean?.id };
    apiPost(
      ENDPOINTS.StartQuizDeductCoins,
      payload,
      () => console.log('Coins deducted successfully'),
      (err) => console.error('Error deducting coins:', err)
    );
  };

  // Fetches all oceans and sets the selected one
  const getOceans = () => {
    setIsLoaderInfo(true);
    apiGetAuth(
      ENDPOINTS.GetOceans,
      (res) => {
        const selectedOcean = res.find((ocean) => ocean.user_selected_option != null) || res[0];
        if (selectedOcean) {
          setOcean(selectedOcean);
          getQuests(selectedOcean?.id);
        }
        setOceans(res);
        setIsLoaderInfo(false);
      },
      (err) => {
        console.error('Error fetching oceans:', err);
        setIsLoaderInfo(false);
      }
    );
  };

  // Fetches quests based on the selected ocean
  const getQuests = (oceanId) => {
    setIsLoaderInfo(true);
    apiGetAuth(
      `${ENDPOINTS.GetQuests}?ocean_id=${oceanId}`,
      (res) => {
        const completedCount = res.filter((stage) => stage.user_quest !== null).length;
        setStages(res);
        setLastCompleteIndex(completedCount);
        setIsLoaderInfo(false);
      },
      (err) => {
        console.error('Error fetching quests:', err);
        setIsLoaderInfo(false);
      }
    );
  };

  useEffect(() => {
    getOceans();
    if (ocean?.id) {
      getQuests(ocean?.id);
    }
  }, [location, ocean?.id]);


  return (
    <div className='quest'>
      <div className='container-fluid p-4'>
        <div className='d-flex justify-content-between align-items-center pb-5 custom-quest-mb-class'>
          <CustomBusinessMoneyButton
            btnTextPro={ocean ? ocean.name : 'Select Ocean'}
            classNamePro='btn-custom-leaderboard'
            customWelcomeClass='custom-leaderboard-class'
            handleOnClick={() => setShowModal(true)}
          />
          <BuyCoinComponent handleOnClick={() => navigate('/admin/coin-purchase')} />
        </div>
        <h1 className='text-white'>Quests:</h1>
        <div className='row pb-3'>
          {stages.map((quest, index) => (
            <div key={index} className='col-lg-4'>
              <CustomQuestBox
                isLocked={index > lastCompleteIndex}
                quest={quest}
                isLeaderBoard={true}
                questionsCount={`${Math.min(quest.correct_question_answers_count || 0, quest.questions_count || 0)} / ${quest.total_questions || 0}`}
                handleClick={() => handleQuestClick(quest, index)}
              />
            </div>
          ))}
        </div>
      </div>

      {user?.type === "guest_user" && (
        <CustomModal
          size="md"
          hideModal={() => navigate("/admin/ocean")}
          showModal={showGuestModal}
          title="Select Ocean"
        >
          <div className="ocean-modal text-center">
            <h2 className='text-white font-24 text-bold skranji-regular'>This feature is not available for guest users</h2>
            <div class="buttons d-flex justify-content-center">
              <CustomSecondaryButton
                btnTextPro="Cancel"
                classNamePro="btn btn-seondary"
                handleOnClick={() => navigate("/admin/ocean")}
              />
              <CustomPrimaryButton
                btnTextPro="Sign Up"
                classNamePro="btn btn-primary mt-2"
                handleOnClick={() => {
                  navigate("/register-form");
                }}
              />
            </div>
          </div>
        </CustomModal>
      )}

      <CustomModal
        size='md'
        showModal={showConfirmationModal}
        hideModal={() => setShowConfirmationModal(false)}
        title='Confirm Quest Entry'
      >
        <div className='confirmation-modal-content text-center'>
          <p className='text-white'>
            It costs 10 Shark Coins to enter the quest, but you can earn 20 Shark Coins if you get more than 8/10. Are you sure you want to proceed?
          </p>
          <div className='mt-3 text-center mb-3'>
            <button
              className='btn btn-secondary me-3'
              onClick={() => {
                startDeductCoins(selectedQuest?.id);
                setShowConfirmationModal(false);
                navigate('/quest-question-answers', {
                  state: { selectedQuest, ocean, stages, lastCompleteIndex },
                });
              }}
            >
              Yes
            </button>
            <button className='btn btn-danger' onClick={() => setShowConfirmationModal(false)}>
              No
            </button>
          </div>
        </div>
      </CustomModal>

      {/* Ocean Selection Modal */}
      <CustomModal
        size='md'
        showModal={showModal}
        hideModal={() => setShowModal(false)}
        title='Select Ocean'
      >
        <div className='ocean-modal text-center'>
          <h2 className='text-white'>Select Ocean</h2>
          {oceans.length > 0 ? (
            oceans.map((item, index) => (
              <QuestionItem
                key={index}
                welcomeicon={`${process.env.REACT_APP_BASE_URL}/${item.image}`}
                text={item.name}
                progressBar={{ now: item.percentage }}
                customTime='4 Hours'
                onClick={() => handleSelectOcean(item)}
                isSelected={ocean?.id === item?.id}
              />
            ))
          ) : (
            <p>No Ocean</p>
          )}
        </div>
      </CustomModal>
    </div>
  );
}

export default Quest;
